import { useEffect, useState } from "react";

import {
    Box,
    Container,
    Typography,
    Paper,
    Button,
    Stack,
    IconButton,
    Chip,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    CircularProgress,
} from "@mui/material";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";

import { useHorarios } from "../../hooks/UseHorario";
import { useHorariosCategoria } from "../../hooks/UseHorario";
import StatusModal from "../../utils/StatusModal";


export const Horario = () => {
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const {
        horarios,
        loading,
        guardarHorario,
        editarHorario,
        borrarHorario,
        cargarHorarios
    } = useHorarios();
   
    const {
    categorias,
    loadingCat,
    errorCat,
    cargarCategorias,
} = useHorariosCategoria();


useEffect(() => {
    cargarCategorias();
    cargarHorarios();
}, []);
   


    // =========================================================
    // ESTADOS
    // =========================================================

    const [openModal, setOpenModal] = useState(false);

    const [modoEdicion, setModoEdicion] = useState(false);

    const [horarioSeleccionado, setHorarioSeleccionado] =
        useState(null);

    const [formulario, setFormulario] = useState({
        categoria_id: "",
        nombre: "",
        archivo: null,
    });

    const [archivoActual, setArchivoActual] = useState("");

    const [statusModal, setStatusModal] = useState({
        open: false,
        type: "success",
        message: "",
    });


  


    // =========================================================
    // MODAL STATUS
    // =========================================================

    const mostrarStatus = (type, message) => {
        setStatusModal({
            open: true,
            type,
            message,
        });
    };


    const cerrarStatus = () => {
        setStatusModal((prev) => ({
            ...prev,
            open: false,
        }));
    };


    // =========================================================
    // ABRIR CREAR
    // =========================================================

    const handleNuevo = () => {

        setModoEdicion(false);

        setHorarioSeleccionado(null);

        setFormulario({
            categoria_id: "",
            nombre: "",
            archivo: null,
        });

        setArchivoActual("");

        setOpenModal(true);
    };


    // =========================================================
    // ABRIR EDITAR
    // =========================================================

   const handleEditar = (horario) => {

    setModoEdicion(true);

    setHorarioSeleccionado(horario);

    setFormulario({
        categoria_id: horario.categoria_id || "",
        nombre: horario.nombre || "",
        archivo: null,
    });

    setArchivoActual(
        horario.archivo ||
        horario.archivo_nombre ||
        horario.nombre_archivo ||
        ""
    );

    setOpenModal(true);
};


    // =========================================================
    // CERRAR FORMULARIO
    // =========================================================

    const cerrarFormulario = () => {

        if (loading) return;

        setOpenModal(false);

        setModoEdicion(false);

        setHorarioSeleccionado(null);

        setFormulario({
            categoria_id: "",
            nombre: "",
            archivo: null,
        });

        setArchivoActual("");
    };


    // =========================================================
    // CAMBIAR INPUT
    // =========================================================

    const handleChange = (event) => {

        const {
            name,
            value,
        } = event.target;

        setFormulario((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    // =========================================================
    // ARCHIVO PDF
    // =========================================================

    const handleArchivo = (event) => {

        const archivo = event.target.files?.[0];

        if (!archivo) return;

        if (archivo.type !== "application/pdf") {

            mostrarStatus(
                "error",
                "Solo puedes seleccionar archivos en formato PDF."
            );

            event.target.value = "";

            return;
        }

        setFormulario((prev) => ({
            ...prev,
            archivo,
        }));
    };


    // =========================================================
    // GUARDAR
    // =========================================================
const handleGuardar = async () => {

    if (!formulario.categoria_id) {
        mostrarStatus(
            "error",
            "Debes seleccionar una categoría."
        );
        return;
    }

    if (!formulario.nombre.trim()) {
        mostrarStatus(
            "error",
            "Debes ingresar el nombre del curso."
        );
        return;
    }

    if (!modoEdicion && !formulario.archivo) {
        mostrarStatus(
            "error",
            "Debes seleccionar un archivo PDF."
        );
        return;
    }

    try {

        const formData = new FormData();

        formData.append(
            "categoria_id",
            formulario.categoria_id
        );

        formData.append(
            "nombre",
            formulario.nombre.trim()
        );

        if (formulario.archivo) {
            formData.append(
                "archivo",
                formulario.archivo
            );
        }

       

        for (const [key, value] of formData.entries()) {
            console.log(key, value);
        }

        if (modoEdicion) {

            await editarHorario(
                horarioSeleccionado.id,
                formData
            );

            cerrarFormulario();

            mostrarStatus(
                "success",
                "El horario se actualizó correctamente."
            );

        } else {

            await guardarHorario(formData);

            cerrarFormulario();

            mostrarStatus(
                "success",
                "El horario se creó correctamente."
            );
        }

        setTimeout(() => {
            cerrarStatus();

        }, 1800);


    } catch (error) {

        console.error(
            "Error al guardar horario:",
            error
        );

        mostrarStatus(
            "error",
            error?.response?.data?.message ||
            "Ocurrió un error al guardar el horario."
        );

        setTimeout(() => {
            cerrarStatus();

        }, 1800);
    }
};


    // =========================================================
    // ELIMINAR
    // =========================================================

    const handleEliminar = async (horario) => {

        const confirmar = window.confirm(
            `¿Estás seguro de eliminar el horario de ${horario.nombre}?`
        );

        if (!confirmar) return;


        try {

            await borrarHorario(horario.id);

            mostrarStatus(
                "success",
                "El horario se eliminó correctamente."
            );
             setTimeout(() => {
            cerrarStatus();

        }, 1800);

        } catch (error) {

            console.error(error);

            mostrarStatus(
                "error",
                error?.response?.data?.message ||
                "No fue posible eliminar el horario."
            );
        }
    };


    // =========================================================
    // VER PDF
    // =========================================================
const handleVerPDF = (horario) => {

    const archivo =
        horario.archivo_url ||
        horario.url ||
        horario.archivo;

    if (!archivo) {
        mostrarStatus(
            "error",
            "No se encontró el archivo PDF."
        );
        return;
    }

    // Si ya viene como URL completa
    const url = archivo.startsWith("http")
        ? archivo
        : `${backendURL}/storage/${archivo}`;

    window.open(url, "_blank");
};

    // =========================================================
    // DATA
    // =========================================================

    const data = horarios || [];


    // =========================================================
    // RENDER
    // =========================================================

    return (
        <Box
            sx={{
                minHeight: "100vh",
                backgroundColor: "#F7F8FC",
                py: 4,
            }}
        >

            <Container maxWidth="xl">

                {/* ================================================= */}
                {/* HEADER */}
                {/* ================================================= */}

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: {
                            xs: "flex-start",
                            md: "center",
                        },
                        flexDirection: {
                            xs: "column",
                            md: "row",
                        },
                        gap: 2,
                        mb: 4,
                    }}
                >

                    <Box>

                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 800,
                                color: "#1E293B",
                                mb: 0.5,
                            }}
                        >
                            Horarios
                        </Typography>

                        <Typography
                            sx={{
                                color: "#64748B",
                                fontSize: "0.95rem",
                            }}
                        >
                            Administra los horarios de clases del
                            establecimiento.
                        </Typography>

                    </Box>


                    <Button
                        variant="contained"
                        startIcon={<AddRoundedIcon />}
                        onClick={handleNuevo}
                        sx={{
                            backgroundColor: "#3157A4",
                            borderRadius: "11px",
                            px: 2.5,
                            py: 1.2,
                            textTransform: "none",
                            fontWeight: 700,
                            boxShadow:
                                "0 6px 16px rgba(49,87,164,0.20)",

                            "&:hover": {
                                backgroundColor: "#264889",
                            },
                        }}
                    >
                        Agregar horario
                    </Button>

                </Box>


                {/* ================================================= */}
                {/* TABLA */}
                {/* ================================================= */}

                <Paper
                    elevation={0}
                    sx={{
                        borderRadius: "18px",
                        border: "1px solid #E5E7EB",
                        backgroundColor: "#FFFFFF",
                        overflow: "hidden",
                    }}
                >

                    {/* CABECERA */}

                    <Box
                        sx={{
                            px: 3,
                            py: 2.5,
                        }}
                    >

                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1.5}
                        >

                            <Box
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: "11px",
                                    backgroundColor: "#EEF3FF",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >

                                <PictureAsPdfRoundedIcon
                                    sx={{
                                        color: "#3157A4",
                                        fontSize: 23,
                                    }}
                                />

                            </Box>

                            <Box>

                                <Typography
                                    sx={{
                                        fontWeight: 750,
                                        color: "#1E293B",
                                    }}
                                >
                                    Horarios de clases
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "0.78rem",
                                        color: "#94A3B8",
                                    }}
                                >
                                    Archivos publicados en el sitio web
                                </Typography>

                            </Box>

                        </Stack>

                    </Box>


                    <Divider />


                    <Box
                        sx={{
                            overflowX: "auto",
                        }}
                    >

                        <Box
                            sx={{
                                minWidth: 750,
                            }}
                        >

                            {/* HEADER */}

                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns:
                                        "1.2fr 1.5fr 2fr 150px",
                                    px: 3,
                                    py: 1.8,
                                    backgroundColor: "#F8FAFC",
                                    borderBottom:
                                        "1px solid #E5E7EB",
                                }}
                            >

                                <Typography
                                    sx={{
                                        fontSize: "0.72rem",
                                        fontWeight: 800,
                                        color: "#64748B",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    Categoría
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "0.72rem",
                                        fontWeight: 800,
                                        color: "#64748B",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    Curso
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "0.72rem",
                                        fontWeight: 800,
                                        color: "#64748B",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    Archivo
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "0.72rem",
                                        fontWeight: 800,
                                        color: "#64748B",
                                        textTransform: "uppercase",
                                        textAlign: "center",
                                    }}
                                >
                                    Acciones
                                </Typography>

                            </Box>


                            {/* LOADING */}

                            {loading && !data.length && (

                                <Box
                                    sx={{
                                        py: 8,
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <CircularProgress
                                        size={30}
                                        sx={{
                                            color: "#3157A4",
                                        }}
                                    />
                                </Box>

                            )}


                            {/* FILAS */}

                           {/* FILAS */}

{!loading && data.map((horario) => (

    <Box
        key={horario.id}
        sx={{
            display: "grid",
            gridTemplateColumns:
                "1.2fr 1.5fr 2fr 150px",
            alignItems: "center",
            px: 3,
            py: 2,
            borderBottom:
                "1px solid #EEF1F5",

            transition:
                "background-color .2s ease",

            "&:hover": {
                backgroundColor:
                    "#FAFBFD",
            },
        }}
    >

        {/* ========================= */}
        {/* CATEGORÍA */}
        {/* ========================= */}

        <Box>

            <Chip
                label={
                    horario.categoria?.name ||
                    "Sin categoría"
                }
                size="small"
                sx={{
                    backgroundColor:
                        "#EEF3FF",
                    color: "#3157A4",
                    fontWeight: 700,
                    borderRadius: "8px",
                    fontSize: "0.72rem",
                }}
            />

        </Box>


        {/* ========================= */}
        {/* NOMBRE DEL CURSO */}
        {/* ========================= */}

        <Typography
            sx={{
                fontWeight: 700,
                color: "#334155",
                fontSize: "0.9rem",
            }}
        >
            {horario.nombre || "Sin nombre"}
        </Typography>


        {/* ========================= */}
        {/* PDF */}
        {/* ========================= */}

        <Stack
            direction="row"
            alignItems="center"
            spacing={1.2}
        >

            <Box
                sx={{
                    width: 38,
                    height: 38,
                    borderRadius: "9px",
                    backgroundColor:
                        "#FEF2F2",
                    display: "flex",
                    alignItems:
                        "center",
                    justifyContent:
                        "center",
                    flexShrink: 0,
                }}
            >

                <PictureAsPdfRoundedIcon
                    sx={{
                        color: "#DC2626",
                        fontSize: 21,
                    }}
                />

            </Box>


            <Typography
                sx={{
                    fontSize: "0.82rem",
                    color: "#475569",
                    fontWeight: 600,
                    overflow: "hidden",
                    textOverflow:
                        "ellipsis",
                    whiteSpace:
                        "nowrap",
                }}
            >
                {horario.archivo_nombre ||
                    horario.archivo ||
                    "Archivo PDF"}
            </Typography>

        </Stack>


        {/* ========================= */}
        {/* ACCIONES */}
        {/* ========================= */}

        <Stack
            direction="row"
            justifyContent="center"
            spacing={0.5}
        >

            {/* VER PDF */}

            <IconButton
                size="small"
                onClick={() =>
                    handleVerPDF(horario)
                }
                sx={{
                    color: "#3157A4",

                    "&:hover": {
                        backgroundColor:
                            "#EEF3FF",
                    },
                }}
            >
                <VisibilityRoundedIcon
                    fontSize="small"
                />
            </IconButton>


            {/* EDITAR */}

            <IconButton
                size="small"
                onClick={() =>
                    handleEditar(horario)
                }
                sx={{
                    color: "#64748B",

                    "&:hover": {
                        backgroundColor:
                            "#F1F5F9",
                    },
                }}
            >
                <EditRoundedIcon
                    fontSize="small"
                />
            </IconButton>


            {/* ELIMINAR */}

            <IconButton
                size="small"
                onClick={() =>
                    handleEliminar(
                        horario
                    )
                }
                sx={{
                    color: "#DC2626",

                    "&:hover": {
                        backgroundColor:
                            "#FEF2F2",
                    },
                }}
            >
                <DeleteOutlineRoundedIcon
                    fontSize="small"
                />
            </IconButton>

        </Stack>

    </Box>

))}


                            {/* SIN REGISTROS */}

                            {!loading && !data.length && (

                                <Box
                                    sx={{
                                        py: 8,
                                        textAlign: "center",
                                    }}
                                >

                                    <PictureAsPdfRoundedIcon
                                        sx={{
                                            fontSize: 45,
                                            color: "#CBD5E1",
                                            mb: 1,
                                        }}
                                    />

                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            color: "#475569",
                                        }}
                                    >
                                        No hay horarios registrados
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: "0.85rem",
                                            color: "#94A3B8",
                                            mt: 0.5,
                                        }}
                                    >
                                        Agrega el primer horario
                                        para comenzar.
                                    </Typography>

                                </Box>

                            )}

                        </Box>

                    </Box>

                </Paper>

            </Container>


            {/* ===================================================== */}
            {/* MODAL CREAR / EDITAR */}
            {/* ===================================================== */}

            <Dialog
                open={openModal}
                onClose={cerrarFormulario}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: "18px",
                    },
                }}
            >

                <DialogTitle
                    sx={{
                        px: 3,
                        pt: 3,
                        pb: 1,
                        fontWeight: 800,
                        color: "#1E293B",
                    }}
                >

                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >

                        <Box>

                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    fontSize: "1.25rem",
                                }}
                            >
                                {modoEdicion
                                    ? "Editar horario"
                                    : "Agregar horario"}
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: "0.8rem",
                                    color: "#94A3B8",
                                    mt: 0.3,
                                }}
                            >
                                Completa la información del horario
                            </Typography>

                        </Box>


                        <IconButton
                            onClick={cerrarFormulario}
                            disabled={loading}
                        >
                            <CloseRoundedIcon />
                        </IconButton>

                    </Stack>

                </DialogTitle>


                <DialogContent sx={{ px: 3, pt: 2 }}>

                    <Stack spacing={2.5}>

                        {/* CATEGORIA */}

                      <TextField
    select
    fullWidth
    label="Categoría"
    name="categoria_id"
    value={formulario.categoria_id}
    onChange={handleChange}
    disabled={loading || loadingCat}
    sx={{
        "& .MuiOutlinedInput-root": {
            borderRadius: "11px",
        },
    }}
>
    {categorias.map((categoria) => (
        <MenuItem
            key={categoria.id}
            value={categoria.id}
        >
            {categoria.name}
        </MenuItem>
    ))}
</TextField>


                        {/* CURSO */}

                        <TextField
    fullWidth
    label="Nombre del curso"
    name="nombre"
    value={formulario.nombre}
    onChange={handleChange}
    disabled={loading}
    placeholder="Ej: 1° Básico A"
    sx={{
        "& .MuiOutlinedInput-root": {
            borderRadius: "11px",
        },
    }}
/>


                        {/* ARCHIVO */}

                        <Box>

                            <Typography
                                sx={{
                                    fontSize: "0.82rem",
                                    fontWeight: 700,
                                    color: "#334155",
                                    mb: 1,
                                }}
                            >
                                Archivo PDF
                            </Typography>


                            <Button
                                component="label"
                                variant="outlined"
                                startIcon={
                                    <UploadFileRoundedIcon />
                                }
                                disabled={loading}
                                fullWidth
                                sx={{
                                    minHeight: 52,
                                    borderRadius: "11px",
                                    borderStyle: "dashed",
                                    textTransform: "none",
                                    justifyContent: "flex-start",
                                    px: 2,
                                    color: "#475569",
                                    borderColor: "#CBD5E1",

                                    "&:hover": {
                                        borderStyle: "dashed",
                                        borderColor:
                                            "#3157A4",
                                        backgroundColor:
                                            "#F8FAFC",
                                    },
                                }}
                            >

                                {formulario.archivo
                                    ? formulario.archivo.name
                                    : modoEdicion && archivoActual
                                        ? archivoActual
                                        : "Seleccionar archivo PDF"}

                                <input
                                    hidden
                                    type="file"
                                    accept="application/pdf,.pdf"
                                    onChange={handleArchivo}
                                />

                            </Button>


                            {modoEdicion && (

                                <Typography
                                    sx={{
                                        mt: 0.8,
                                        fontSize: "0.72rem",
                                        color: "#94A3B8",
                                    }}
                                >
                                    Si no seleccionas un nuevo PDF,
                                    se conservará el archivo actual.
                                </Typography>

                            )}

                        </Box>

                    </Stack>

                </DialogContent>


                <DialogActions
                    sx={{
                        px: 3,
                        py: 2.5,
                        gap: 1,
                    }}
                >

                    <Button
                        onClick={cerrarFormulario}
                        disabled={loading}
                        sx={{
                            borderRadius: "10px",
                            px: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            color: "#64748B",
                        }}
                    >
                        Cancelar
                    </Button>


                    <Button
                        variant="contained"
                        onClick={handleGuardar}
                        disabled={loading}
                        sx={{
                            borderRadius: "10px",
                            px: 2.5,
                            textTransform: "none",
                            fontWeight: 700,
                            backgroundColor: "#3157A4",

                            "&:hover": {
                                backgroundColor: "#264889",
                            },
                        }}
                    >

                        {loading ? (
                            <CircularProgress
                                size={21}
                                sx={{
                                    color: "#fff",
                                }}
                            />
                        ) : (
                            modoEdicion
                                ? "Actualizar horario"
                                : "Guardar horario"
                        )}

                    </Button>

                </DialogActions>

            </Dialog>


            {/* ===================================================== */}
            {/* STATUS MODAL */}
            {/* ===================================================== */}

            <StatusModal
                open={statusModal.open}
                type={statusModal.type}
                message={statusModal.message}
                onClose={cerrarStatus}
            />

        </Box>
    );
};